import React from 'react';
import { Hero } from './components/landing/Hero';
import { Features } from './components/landing/Features';
import { HowItWorks } from './components/landing/HowItWorks';
import { Roadmap } from './components/landing/Roadmap';
import { AboutUs } from './components/landing/AboutUs';
import { CallToAction } from './components/landing/CallToAction';

const LandingPage: React.FC = () => {
  return (
    <div>
      <Hero />
      <Features />
      <HowItWorks />
      <Roadmap />
      <AboutUs />
      <CallToAction />
    </div>
  );
};

export default LandingPage;